function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinejoin: "round",
  d: "M2.18 5.69a3.51 3.51 0 013.51-3.51h24.62a3.51 3.51 0 013.51 3.51v26.13l-7-7H5.69a3.51 3.51 0 01-3.51-3.52V5.69z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M27.79 10H8.37M21.82 17H8.37"
}));

function SvgPress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 34"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgPHBhdGggc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNMC4xNzk5ODU3MzUsMy42OSBDMC4xNzk5ODU3MzUsMS43NTE0ODA1MyAxLjc1MTQ4MDUzLDAuMTggMy42OSwwLjE4IEwyOC4zMSwwLjE4IEMzMC4yNDg1MTk1LDAuMTggMzEuODIsMS43NTE0ODA1MyAzMS44MiwzLjY5IEwzMS44MiwyOS44MiBMMjQuODIsMjIuODIgTDMuNjksMjIuODIgQzIuNzU3MzU0OTIsMjIuODIwMDAzOCAxLjg2MzA1Mzg3LDIyLjQ0ODgyODkgMS4yMDQ1MTI5NiwyMS43ODg0MTE4IEMwLjU0NTk3MjA2LDIxLjEyNzk5NDcgMC4xNzczNDI4OTEsMjAuMjMyNjQxMyAwLjE3OTk4NTczNSwxOS4zIEwwLjE3OTk4NTczNSwzLjY5IFoiLz4KICAgIDxsaW5lIHgxPSIyNS43OSIgeDI9IjYuMzciIHkxPSI4IiB5Mj0iOCIgc3Ryb2tlPSIjMjNDMzg2Ii8+CiAgICA8bGluZSB4MT0iMTkuODIiIHgyPSI2LjM3IiB5MT0iMTUiIHkyPSIxNSIgc3Ryb2tlPSIjMjNDMzg2Ii8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgPress as ReactComponent };